<template>
  <div style="height: 100vh;width: 100%;background-color: #5e5e5e;">
    <el-col class="io-box">
      <span class="io-title">管理员验证</span>

      <el-input class="io-name-input" placeholder="请输入您的用户名" v-model="username"/>

      <el-input class="io-psw-input" placeholder="请输入您的密码" type="password" v-model="password"/>

      <el-button class="login-button" @click="login">登 录</el-button>
    </el-col>
  </div>
</template>

<script>
import md5 from 'js-md5'
import { Message } from 'element-ui'
import { routerTo } from '../router'
export default {
  name: 'LoginPage',
  data() {
    return {
      username: '',
      password: ''
    }
  },
  created() {
    this.addEnterKeyEvent()
  },
  methods: {
    login() {
      let userInfo = {
        password: md5(this.password),
        userAccount: this.username
      };
      this.$api.systemManage.loginIn(userInfo).then(res => {
        if (res.code !== 500) {
          Message.success(res.message)
          sessionStorage.setItem('token', res.data.token)
          routerTo(this.$router, 'ManageNews')
        } else {
          Message.error(res.message)
        }
      })
    },
    addEnterKeyEvent() {
      let _self = this;
      onkeydown = function(e) {
        if (e.code === 'Enter' || e.code === 'NumpadEnter') {
          _self.login()
        }
      }
    }
  }
}
</script>

<style scoped>
  .io-box{
    position: absolute;
    left: 36%;
    top: 20%;
    width: 28%;
    height: 57.41%;
  }
  .io-title{
    position: absolute;
    top: 18%;
    left: 15.63%;
    width: 69.06%;
    height: 5.63%;
    font-size: 28px;
    font-weight: bold;
    line-height: 50px;
    font-family: PingFang-SC-Regular,fantasy;
    cursor: default;
    color: rgba(40, 40, 40, 1);
  }
  .io-name-input{
    position: absolute;
    top: 30%;
    left: 20%;
    width: 60%;
    height: 20px;
    font-size: 16px;
    color: rgba(40, 40, 40, 1);
  }
  .io-psw-input{
    position: absolute;
    top: 44%;
    left: 20%;
    width: 60%;
    height: 20px;
    font-size: 16px;
    color: rgba(40, 40, 40, 1);
  }
  .login-button{
    position: absolute;
    top: 58%;
    left: 32%;
    width: 36%;
    height: 8%;
    background: transparent;
    color: rgb(250, 250, 250);
    border: 2px solid rgb(102, 205, 253);
    border-radius: 8px;
    font-size: 16px;
  }
  .login-button:hover{
    background: rgba(102, 205, 253, 0.8);
    color: rgb(250, 250, 250);
  }
</style>



// WEBPACK FOOTER //
// src/components/LoginPage.vue